
const FieldActivityClosureStatus = {
    "OPEN": "845280000",
    "CONTAINER_NOT_OUT": "845280001",
    "FOREMAN_INVESTIGATE": "845280002",
    "REPAIRED": "845280003",
    "REPLACED": "845280004",
    "REMOVED": "845280005",
    "DELIVERED": "845280006"
};

export default FieldActivityClosureStatus;